import React from 'react'


const Container = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="container mx-auto pb-5">
      {children}
    </div>
  )
}


export default Container;
